module.exports = "https://coursera_assets.s3.amazonaws.com/images/1972c3dca94d3c67ef8cb7dd96806382.png";